import { db, storage } from '../../firebase';

export const setHeroImages = (heroImages) => ({
  type: 'SET_HERO_IMAGES',
  heroImages,
});

export const startSetHeroImages = () => {
  return (dispatch) => db.getHeroImages().on('value', (snapshot) => {
    const heroImages = [];

    snapshot.forEach((childSnapshot) => {
      const heroImage = {id: childSnapshot.key, ...childSnapshot.val()};

      storage.getHeroImageURL(heroImage.filename)
        .then(result => {
          heroImage.downloadURL = result;
          heroImages.push(heroImage);
        });

    });

    dispatch(setHeroImages(heroImages));
  });
};



// WEBPACK FOOTER //
// ./src/store/actions/heroImages.js